import type { SVGProps } from 'react';

export const Package = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.25 19.575v-7.15L5 8.8v6.975c0 .05.008.1.025.15.033.05.075.083.125.1l6.1 3.55Zm1.5 0 6.1-3.55a.15.15 0 0 0 .1-.1.27.27 0 0 0 .05-.15V8.8l-6.25 3.625v7.15ZM11.1 21.2l-6.7-3.85a1.942 1.942 0 0 1-.675-.65 1.896 1.896 0 0 1-.225-.9V8.2c0-.317.075-.608.225-.875.167-.283.392-.508.675-.675l6.7-3.85a1.747 1.747 0 0 1 1.8 0l6.7 3.85c.283.167.5.392.65.675.167.267.25.558.25.875v7.6c0 .317-.083.617-.25.9a1.74 1.74 0 0 1-.65.65l-6.7 3.85a1.747 1.747 0 0 1-1.8 0Zm4.75-12.3 2.325-1.325-6.025-3.5a.472.472 0 0 0-.3 0l-2.175 1.25L15.85 8.9ZM12 11.15l2.325-1.35L8.15 6.225l-2.325 1.35L12 11.15Z" />
    </svg>
  );
};
